export const START_REUPLOAD_DOCUMENT = 'START_REUPLOAD_DOCUMENT';
export const REUPLOAD_PROGRESS = 'REUPLOAD_PROGRESS';
export const REUPLOAD_COMPLETE = 'REUPLOAD_COMPLETE';